import { ref } from 'vue';
import { useUserPackage } from '@/composables/useUserPackage';
import type { UpgradeAgentName } from '@/utils/upgrade-tracking';

const visible = ref(false);
const agentName = ref<UpgradeAgentName>('home');

export function useProCreditsLimitModal() {
    function open(nextAgentName: UpgradeAgentName = 'home') {
        agentName.value = nextAgentName;
        visible.value = true;
    }

    function close() {
        visible.value = false;
    }

    return {
        visible,
        agentName,
        open,
        close,
    };
}

export function showProCreditsLimitModal(nextAgentName: UpgradeAgentName = 'home'): boolean {
    const { isEnterpriseUser, isPro } = useUserPackage();
    if (!isPro.value || isEnterpriseUser.value) return false;

    agentName.value = nextAgentName;
    visible.value = true;
    return true;
}
